interface IconProps {
  fill?: string
}

export const Cap = ({ fill }: IconProps) => {
  return (
    <svg
      height='32px'
      viewBox='0 0 466 406'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M172.7 0.97C166.2 0.87 156.6 3.84 157.1 10.5C157.5 16.12 193.8 14.58 193.9 10.29C194.1 4.08 179.8 1.03 172.7 0.97ZM98.1 42.96C82.1 50.1 65.01 59.1 52.28 71.3C18.66 106.4 -3.84001 159.2 1.53999 243.9C17.79 266.4 78 280.6 109.6 285.6C160.7 263.6 315.9 240.3 374.7 263.5C373.3 215.8 360.9 157.9 329.6 111.6C310 75.8 279.4 49.6 239.7 35.76C194.1 21.26 142.7 22.66 98.1 42.96ZM128.4 303C159.3 349 190.6 385.9 237.1 404.6C239.7 405.1 243.7 405.7 246.9 403.3C285.7 374 393.7 369.7 459.5 388.5C463.1 389.5 466.6 384 464.6 380.3C447.2 348.6 427.7 316.6 389.6 290.3C310.8 257.7 198.5 282.5 128.4 303Z'
        fill={fill || 'black'}
      />
    </svg>
  )
}
